import { useEffect, useState, useRef, createRef } from 'react';
import Select from 'react-select';
import './Collections.css';
import { Grid, Button, TextField, InputLabel } from '@mui/material';
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import NotInterestedOutlinedIcon from '@mui/icons-material/NotInterestedOutlined';
import {
  TextWithCount,
  AsyncSelectField,
  ThumbUploadField,
} from 'components/Fields';
import { adminAPI } from 'services/admin';
import { TargetAudiencesField } from 'components/Fields/TargetAudiencesField';
import { useNotification } from 'hooks/useNotification';
import { getAuthData } from 'utils/authentication';
import dayjs from 'dayjs';
import { AgeRatingField } from '../videos/AgeRatingField'



function CollectionStep3(props) {
  const {
    control,
    // errors,
    watch,
    setValue,
    register,
    getValues,
    viewFields,
    collectionResponse,
  } = props;

  const { setNotify } = useNotification();
  const [keyWordsList, setKeyWordsList] = useState([]);
  const [keyWords, setKeyWords] = useState([]);
  const [wordsList, setWordsList] = useState([]);
  const [selectedOption, setSelectedOption] = useState({});
  const [showKeyWords, setShowKeyWords] = useState([]);
  const [title, setTitle] = useState('');
  const keyWordsRef = useRef(null);
  const launchingCountryRef = createRef();
  const [countriesList, setCountriesList] = useState([]);


  
  const getCountries = async () => {
    try {
      const { session } = await getAuthData();
      const path = `/admin/countries`;

      const data = {
        createdBy: {
          userId: session.getIdToken().payload.sub,
          name: session.getIdToken().payload.username,
        },
      };

      return await adminAPI.get(path, data);
    } catch (error) {
      console.log(error);
    }
  };


  const deleteKeyWordValue = (val, word) => {
    let otherkeys = keyWords.filter(word => word.value !== val);
    setKeyWords(otherkeys);
  };

  const deleteKeyword = keyword => {
    let otherkeys = keyWords.filter(word => word.key !== keyword.key);
    setKeyWords(otherkeys);
  };

  const addKeyWords = () => {
    let keywordsTemp = getValues('wordsSelectedFromKey');
    let selected_key = getValues('selected_key');

    if (!selected_key) {
      setNotify({
        isOpen: true,
        message: 'Selecione uma chave para adiciona-la.',
        type: 'info',
        title: "Campo 'Chave' não pode ser vazio.",
      });
      return;
    }
    if (keywordsTemp.length === 0) {
      setNotify({
        isOpen: true,
        message: 'Selecione um valor para a chave.',
        type: 'info',
        title: "Campo 'Palavra' não pode ser vazio.",
      });
      return;
    }
    for (let item of keywordsTemp) {
      setKeyWords(prevKeywords => [
        ...prevKeywords,
        {
          key: selected_key.label,
          value: item.value,
        },
      ]);
    }
    keyWordsRef?.current?.clearValue();
  };

  const handleSelectedOptionChange = (selectId, selected) => {
    setSelectedOption(prevSelectedOptions => ({
      ...prevSelectedOptions,
      [selectId]: selected,
    }));
    setValue('selected_key', selected);
  };

  const handleSelectedKeyWords = values => {
    setValue('wordsSelectedFromKey', values);
  };

  useEffect(() => {
    setValue('keywords', keyWords);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyWords]);

  useEffect(() => {
    if (collectionResponse?.title) {
      setTitle(collectionResponse?.title);
      setValue('title', collectionResponse?.title);
    }
    if (collectionResponse?.shortDescription) {
      setValue('shortDescription', collectionResponse?.shortDescription);
    }
    if (collectionResponse?.integraDescription) {
      setValue('integraDescription', collectionResponse?.integraDescription);
    }
    if (collectionResponse?.fullDescription) {
      setValue('fullDescription', collectionResponse?.fullDescription);
    }
    if (collectionResponse?.keywords?.length > 0) {
      if (collectionResponse?.keywords[0].values?.length > 0) {
        setValue('keywords', []);
        setShowKeyWords([]);
      } else {
        setKeyWords(collectionResponse?.keywords);
        setValue('keywords', collectionResponse?.keywords);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collectionResponse]);

  useEffect(() => {
    setShowKeyWords([]);
    let arrayKeyTemp = getValues('keywords');
    let newKeys = [];
    if (arrayKeyTemp?.length > 0) {
      for (let item of arrayKeyTemp) {
        let tempArray = [];
        let tempKey = item.key;
        for (let item2 of keyWords) {
          if (tempKey === item2.key) {
            tempArray.push(item2.value);
          }
        }
        newKeys.push({ key: item.key, value: tempArray });
      }
      const uniqueAuthors = newKeys.filter(
        (value, index, self) =>
          index === self.findIndex(t => t.key === value.key)
      );
      setShowKeyWords(uniqueAuthors);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyWords]);

  useEffect(() => {
    setValue('keywords', keyWords);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyWords]);

  useEffect(() => {
    if (countriesList.length === 0) getAllCountries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAllCountries = async () => {
    let response = await getCountries();
    let paisTemp = [];
    if (response?.countryList?.length) {
      for (let c of response.countryList) {
        paisTemp.push({
          acronym: c.acronym,
          id: c.id,
          label: c.name,
          value: c.id,
          countryId: c.id,
        });
      }
    }
    setCountriesList(paisTemp);
  };

  return (
    <div id="collection-step-three">
      <div className="step-container">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className="video_label-title">Dados Obrigatórios</div>
            <TextWithCount
              id="collection-title"
              name="title"
              label="Título"
              placeholder="Digite o título"
              maxLength={72}
              control={control}
              defaultValue={title}
              disabled={viewFields}
            />
          </Grid>

          <Grid item xs={8}>
            <Form.Group className="mb-3" controlId="formName">
              <InputLabel className="form-label mb-3" htmlFor="name">
                País(es) de origem {' '}
                {/* <span style={{ fontSize: 12, color: '#6082B6' }}>(Máx. 5)</span> */}
              </InputLabel>

              <Controller
                name={'launchingCountry'}
                control={control}
                // rules={{ required: true }}
                render={({ field: { onChange, value, onBlur } }) => {
                  return (
                    <Select
                      id="video-lauching-country"
                      isMulti
                      placeholder="Selecione o(s) país(es)"
                      options={countriesList}
                      onChange={values => {
                        onChange(
                          values?.map(country => ({
                            countryId: country.value,
                            name: country.label,
                          }))
                        );
                      }}
                      onBlur={onBlur}
                      value={value?.map(({ countryId, name }) => ({
                        value: countryId,
                        label: name,
                      }))}
                      // isOptionDisabled={() => value?.length >= 5}
                      selectRef={launchingCountryRef}
                      isDisabled={viewFields}
                    />
                  );
                }}
              />
              {/* {errors.launchingCountry &&
              errors.launchingCountry.type === 'required' ? (
                <div className="text-danger">
                  <span>{'O campo é obrigatório!'}</span>
                </div>
              ) : null} */}
            </Form.Group>
          </Grid>

          <Grid item xs={4}>
            <Form.Group className="mb-3" controlId="formName">
              <InputLabel
                className="form-label"
                htmlFor="name"
                style={{ marginBottom: 0 }}>
                Ano
              </InputLabel>

              <Controller
                name="launchYear"
                control={control}
                defaultValue={null}
                // rules={{ required: true }}
                render={({ field: { onChange, value, onBlur } }) => (
                  <DatePicker
                    format="yyyy"
                    value={value ? new Date('01/01/' + value) : null}
                    onBlur={onBlur}
                    maxDetail="decade"
                    showYearPicker
                    onChange={newValue => {
                      if (
                        new Date(newValue).getFullYear() >
                        new Date().getFullYear()
                      ) {
                        setNotify({
                          message:
                            'Ano de lançamento não pode ser posterior ao ano atual!',
                          type: 'info',
                          title: 'Atenção!',
                        });
                        return;
                      }
                      onChange(
                        newValue ? dayjs(new Date(newValue)).year() : null
                      );
                    }}
                    disabled={viewFields}
                    className="custom-datepicker-year"
                    id="video-launch-year"
                  />
                )}
              />
              {/* {errors.launchYear && errors.launchYear.type === 'required' ? (
                <div className="text-danger">
                  <span>{'O campo é obrigatório!'}</span>
                </div>
              ) : null} */}
            </Form.Group>
          </Grid>



          <Grid item xs={6} sx={{ paddingTop: '0 !important' }}>
            <TargetAudiencesField
              id="collection-targetAudiences"
              name="targetAudiences"
              control={control}
              disabled={viewFields}
            />
          </Grid>
          <Grid item xs={6}>
              <AgeRatingField
                control={control}
                watch={watch}
                viewFields={viewFields}
                setValue={setValue}
              />
          </Grid>
          <Grid item xs={12}>
            <TextWithCount
              id="collection-integraDescription"
              name="integraDescription"
              label="Descrição da Integra"
              placeholder="Digite a apresentação da coleção"
              maxLength={200}
              control={control}
              disabled={viewFields}
              multiline
            />
            <TextWithCount
              id="collection-shortDescription"
              name="shortDescription"
              label="Descrição curta"
              placeholder="Descrição curta"
              maxLength={140}
              control={control}
              disabled={viewFields}
              multiline
            />
            <TextWithCount
              id="collection-fullDescription"
              name="fullDescription"
              label="Descrição longa"
              placeholder="Descrição longa"
              maxLength={5000}
              control={control}
              disabled={viewFields}
              multiline
            />
            <TextWithCount
              id="collection-technicalSheet"
              name="technicalSheet"
              label="Ficha técnica"
              placeholder="Ficha técnica"
              maxLength={3000}
              control={control}
              disabled={viewFields}
              multiline
            />
            <Form.Group
              className="mb-3"
              style={{ height: 'auto' }}
              controlId="formUnit">
              <InputLabel
                className="form-label"
                id="select-standard-label"
                htmlFor="units">
                Unidades
              </InputLabel>
              <AsyncSelectField
                id="collection-units"
                name="units"
                isMulti
                placeholder="Buscar..."
                isDisabled={viewFields}
                control={control}
                url="/admin/units?performance=true&limit=10&name=#name&sortBy=name&offset=#offset"
                responseKey="unitList"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formName">
              <div className="label-content">
                <label className="max-char-name">Opcional</label>
                <InputLabel className="form-label" htmlFor="name">
                  Canal
                </InputLabel>
              </div>
              <AsyncSelectField
                id="collection-channels"
                name="channels"
                isMulti
                placeholder="Buscar..."
                isDisabled={viewFields}
                control={control}
                url="/admin/channels?performance=true&limit=10&name=#name&sortBy=name&offset=#offset"
                responseKey="channelList"
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formName">
              <InputLabel className="form-label" htmlFor="name">
                Crédito -{' '}
                <span style={{ fontSize: 12, color: '#6082B6' }}>(Máx. 5)</span>
              </InputLabel>
              <AsyncSelectField
                id="collection-credits"
                name="personalitiesCredits"
                isMulti
                placeholder="Buscar..."
                control={control}
                url="/admin/personalities?performance=true&limit=10&name=#name&sortBy=name&offset=#offset"
                responseKey="personalityList"
                isDisabled={viewFields}
                controllerProps={{
                  rules: {
                    required: 'Campo é obrigatório',
                    validate: value => {
                      if (
                        typeof value === 'object' &&
                        Object.keys(value).length === 0
                      ) {
                        return 'This field is required.';
                      }
                      return true;
                    },
                  },
                }}
              />
            </Form.Group>
          </Grid>
          <Grid item xs={12}>
            <ThumbUploadField
              watch={watch}
              control={control}
              register={register}
              getValues={getValues}
              viewFields={viewFields}
              variant="collections"
            />
          </Grid>
          <Grid item xs={12}>
            <div className="video_label-title">Dados Opcionais</div>
            <Form.Group className="mb-3" controlId="formName">
              <InputLabel className="form-label" htmlFor="name">
                Com quem -{' '}
                <span style={{ fontSize: 12, color: '#6082B6' }}>
                  (Máx. 20)
                </span>
              </InputLabel>

              <AsyncSelectField
                id="collection-personalities"
                name="personalities"
                isMulti
                placeholder="Buscar..."
                control={control}
                isDisabled={viewFields}
                url="/admin/personalities?performance=true&limit=10&name=#name&sortBy=name&offset=#offset"
                responseKey="personalityList"
              />
            </Form.Group>
          </Grid>
          <Grid item xs={4}>
            <Form.Group className="mb-3" controlId="formChave">
              <InputLabel className="form-label" htmlFor="chave">
                Chave
              </InputLabel>

              <AsyncSelectField
                id="collection-selected-key"
                name="selected_key"
                placeholder="Buscar..."
                control={control}
                loadOptions={async (search, prevOptions) => {
                  if (search.length < 3)
                    return {
                      options: [],
                      hasMore: false,
                    };

                  const newOffset = prevOptions.length;
                  const requestUrl =
                    '/admin/keywords?performance=true&limit=10&key=#key&sortBy=name&offset=#offset'
                      .replace('#key', search)
                      .replace('#offset', newOffset);

                  try {
                    const response = await adminAPI.get(requestUrl);

                    const data = response.keywordList;
                    const total = response.totalItemsCountFiltered;
                    setKeyWordsList(data);
                    const optionsResult = data.map(data => ({
                      label: data.key,
                      value: data.id,
                    }));

                    const hasMore = newOffset + optionsResult.length < total;

                    return {
                      options: optionsResult,
                      hasMore: hasMore,
                    };
                  } catch (error) {
                    return { options: [], hasMore: false };
                  }
                }}
                isDisabled={viewFields}
                value={
                  selectedOption.keyword
                    ? selectedOption.keyword
                    : { value: 'all', label: 'Selecionar a chave' }
                }
                onChange={selected => {
                  if (keyWordsList?.length) {
                    keyWordsRef?.current?.clearValue();
                    setValue('wordsSelectedFromKey', []);

                    const selectedKeyItem = keyWordsList.find(
                      item => selected?.label === item.key
                    );

                    if (selectedKeyItem) {
                      const valArray = [
                        ...(selectedKeyItem.values || []),
                        ...(selectedKeyItem.value || []),
                      ].map(val => ({ label: val, value: val }));
                      setWordsList(valArray);
                    }
                  }
                  handleSelectedOptionChange('keyword', selected);
                }}
              />
            </Form.Group>
          </Grid>
          <Grid item xs={8}>
            <Form.Group className="mb-3" controlId="formKeywords">
              <InputLabel
                className="form-label"
                id="select-standard-label"
                htmlFor="values">
                Palavra
              </InputLabel>
              <Controller
                name="wordsSelectedFromKey"
                control={control}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { errors, invalid, isTouched, isDirty },
                  formState,
                }) => (
                  <Select
                    id="collection-keyword"
                    isMulti
                    name="wordsSelectedFromKey"
                    isSearchable={true}
                    ref={keyWordsRef}
                    isClearable={true}
                    placeholder={'Selecione a(s) palavra(s)'}
                    options={wordsList}
                    onChange={handleSelectedKeyWords}
                    onBlur={onBlur}
                    isDisabled={viewFields}
                  />
                )}
              />
            </Form.Group>
          </Grid>

          <Grid item xs={12}>
            <Button
              disabled={viewFields}
              style={{
                textTransform: 'initial',
              }}
              component="label"
              onClick={addKeyWords}
              id="collection-add-keywords">
              + Adicionar palavra(s) chave(s)
            </Button>
          </Grid>
          {showKeyWords.map((kword, index) => (
            <>
              <Grid item xs={4} key={index}>
                <Form.Group className="mb-3" controlId="formChave">
                  <InputLabel className="form-label" htmlFor="chave">
                    Chave
                  </InputLabel>
                  <TextField
                    style={{ background: '#EFEFEF', color: '#fff' }}
                    id="collection-key"
                    disabled
                    value={kword.key}
                    InputProps={{
                      readOnly: true,
                    }}
                    variant="standard"
                  />
                </Form.Group>
              </Grid>
              <Grid item xs={6} key={kword.key}>
                <Form.Group
                  className="mb-3"
                  controlId="formChave"
                  id="collection-word-list">
                  <InputLabel className="form-label" htmlFor="chave">
                    Palavra
                  </InputLabel>

                  <ul className="selected-keywords" key={kword.key}>
                    {kword.value.map((val, index) => (
                      <li
                        key={index}
                        id="collection-word-item"
                        className={`${
                          viewFields
                            ? 'selected-keywords-item disabled-menu'
                            : 'selected-keywords-item '
                        }`}
                        onClick={() => deleteKeyWordValue(val, kword)}>
                        {val}
                        <CloseOutlinedIcon
                          style={{ cursor: 'pointer' }}
                          fontSize="small"
                        />
                      </li>
                    ))}
                  </ul>
                </Form.Group>
              </Grid>
              <Grid item xs={2} key={index + '-' + kword}>
                <Button
                  id="collection-remove-keyword-button"
                  disabled={viewFields}
                  color="error"
                  style={{
                    textTransform: 'capitalize',
                    color: 'rgba(255, 98, 98, 1)',
                  }}
                  startIcon={<NotInterestedOutlinedIcon />}
                  onClick={() => deleteKeyword(kword)}>
                  Remover
                </Button>
              </Grid>
            </>
          ))}
        </Grid>
      </div>
    </div>
  );
}

export default CollectionStep3;
